import {
    AnimationBaseController,
    GameApiBase,
    GameRandom,
    GameStorageManager,
    IAnimationControllerConfiguration,
    Inject
} from "@denishussar/html5-game-engine";
import {GameModel} from "../../../Models/Game/GameModel";
import {AnimationContents} from "../../../../AnimationContents";
import {ButtonController, IButtonControllerOptions} from "../../../Common/ButtonController";
import {GameLogic} from "../../../Logic/GameLogic";

export class PlayerNameController extends AnimationBaseController {
    $model: GameModel;

    public constructor(@Inject private _options: any,
                       @Inject private _random: GameRandom,
                       @Inject private _gameLogic: GameLogic,
                       @Inject private readonly _storageManager: GameStorageManager) {
        super("PlayerNameController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        // if(!this.$model.player.guid){
        //     this.$model.player.guid = this._random.createGUID();
        //     this._gameLogic.save();
        // }
        //
        // if(!this.$model.player.name){
        //     this.$model.player.name = "Guest_" + this._random.integer(12, 12000);
        //     this._gameLogic.save();
        // }

        let playerGuid = this._storageManager.loadData("-playerGuid");
        if (!playerGuid) {
            playerGuid = this._random.createGUID();
            this._storageManager.saveData("-playerGuid", playerGuid);
        }

        let playerName = this._storageManager.loadData("-playerName");
        if (!playerName) {
            playerName = "Guest_" + this._random.integer(12, 12000);
            this._storageManager.saveData("-playerName", playerName);
        }

        this.$model.playerGuid = playerGuid;
        this.$model.playerName = playerName;

        return {
            animationContent: AnimationContents.INTRO_SCREEN_JSON,
            libraryName: "container",
            childControllers: {
                StartButton: {
                    instanceName: "window.btn_ok",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this._gameLogic.showGameLeaderboards();
                        },
                        hotKey: "SPACE"
                    }
                }
            },
        };
    }

    protected onInitialize(): void {
    }
}

